<template>
    <div class="killerBg relative flex">
        <div
            class="killerBg splashAnimation absolute z-10 flex h-full w-full items-center justify-center"
        >
            <img
                src="@/assets/images/games/killer/killerSplash.svg"
                :alt="$t('killer.logo_alt')"
                class="absolute h-full max-w-[unset]"
            />
            <img
                src="@/assets/images/games/killer/killerTitle.svg"
                :alt="$t('killer.dartboard_alt')"
                class="max-w-120 pb-16"
            />
        </div>
        <TurnSplash v-if="showTurnIndicator" :profile="player1" />
        <KillerTurnSplash />
        <div
            class="flex h-full w-full flex-col items-center justify-between bg-[url('@/assets/images/games/killer/boardPattern.svg')] bg-size-[auto_100%] bg-center p-6"
        >
            <Board :sections="sections" />
            <TurnIndicator class="" :profile="player1" />
            <ScoreIndicator :throws="2" :color="player1.color" />
        </div>
    </div>
</template>

<script>
import Board from '@/components/games/killer/Board.vue'
import TurnIndicator from '@/components/games/killer/TurnIndicator.vue'
import ScoreIndicator from '@/components/games/killer/ScoreIndicator.vue'
import TurnSplash from '@/components/games/killer/TurnSplash.vue'
import { useMatchStore } from '@/stores/match.js'
import KillerTurnSplash from '@/components/games/killer/KillerTurnSplash.vue'

export default {
    name: 'KillerView',
    components: { TurnSplash, Board, TurnIndicator, ScoreIndicator, KillerTurnSplash },
    data() {
        return {
            showTurnIndicator: false,

            sections: {
                3: {
                    angle: 0,
                    hits: Math.round(Math.random() * 3),
                    color: '#0EC1FF',
                    avatar: new URL('@/assets/images/profiles/player_1.png', import.meta.url).href,
                },
                17: {
                    angle: 18,
                    hits: Math.round(Math.random() * 3),
                    color: '#FF0000',
                    avatar: new URL('@/assets/images/profiles/player_1.png', import.meta.url).href,
                },
                2: {
                    angle: 36,
                    hits: Math.round(Math.random() * 3),
                    color: '#C000FF',
                    avatar: new URL('@/assets/images/profiles/player_1.png', import.meta.url).href,
                },
                15: {
                    angle: 54,
                    hits: Math.round(Math.random() * 3),
                    color: '#1AD200',
                    avatar: new URL('@/assets/images/profiles/player_1.png', import.meta.url).href,
                },
                10: {
                    angle: 72,
                    hits: Math.round(Math.random() * 3),
                    color: '#0EC1FF',
                    avatar: new URL('@/assets/images/profiles/player_1.png', import.meta.url).href,
                },
                6: {
                    angle: 90,
                    hits: Math.round(Math.random() * 3),
                    color: '#FF0000',
                    avatar: new URL('@/assets/images/profiles/player_1.png', import.meta.url).href,
                },
                13: {
                    angle: 108,
                    hits: Math.round(Math.random() * 3),
                    color: '#C000FF',
                    avatar: new URL('@/assets/images/profiles/player_1.png', import.meta.url).href,
                },
                4: {
                    angle: 126,
                    hits: Math.round(Math.random() * 3),
                    color: '#1AD200',
                    avatar: new URL('@/assets/images/profiles/player_1.png', import.meta.url).href,
                },
                18: {
                    angle: 144,
                    hits: Math.round(Math.random() * 3),
                    color: '#0EC1FF',
                    avatar: new URL('@/assets/images/profiles/player_1.png', import.meta.url).href,
                },
                1: {
                    angle: 162,
                    hits: Math.round(Math.random() * 3),
                    color: '#FF0000',
                    avatar: new URL('@/assets/images/profiles/player_1.png', import.meta.url).href,
                },
                20: {
                    angle: 180,
                    hits: Math.round(Math.random() * 3),
                    color: '#C000FF',
                    avatar: new URL('@/assets/images/profiles/player_1.png', import.meta.url).href,
                },
                5: {
                    angle: 198,
                    hits: Math.round(Math.random() * 3),
                    color: '#1AD200',
                    avatar: new URL('@/assets/images/profiles/player_1.png', import.meta.url).href,
                },
                12: {
                    angle: 216,
                    hits: Math.round(Math.random() * 3),
                    color: '#0EC1FF',
                    avatar: new URL('@/assets/images/profiles/player_1.png', import.meta.url).href,
                },
                9: {
                    angle: 234,
                    hits: Math.round(Math.random() * 3),
                    color: '#FF0000',
                    avatar: new URL('@/assets/images/profiles/player_1.png', import.meta.url).href,
                },
                14: {
                    angle: 252,
                    hits: Math.round(Math.random() * 3),
                    color: '#C000FF',
                    avatar: new URL('@/assets/images/profiles/player_1.png', import.meta.url).href,
                },
                11: {
                    angle: 270,
                    hits: Math.round(Math.random() * 3),
                    color: '#1AD200',
                    avatar: new URL('@/assets/images/profiles/player_1.png', import.meta.url).href,
                },
                8: {
                    angle: 288,
                    hits: Math.round(Math.random() * 3),
                    color: '#0EC1FF',
                    avatar: new URL('@/assets/images/profiles/player_1.png', import.meta.url).href,
                },
                16: {
                    angle: 306,
                    hits: Math.round(Math.random() * 3),
                    color: '#FF0000',
                    avatar: new URL('@/assets/images/profiles/player_1.png', import.meta.url).href,
                },
                7: {
                    angle: 324,
                    hits: Math.round(Math.random() * 3),
                    color: '#C000FF',
                    avatar: new URL('@/assets/images/profiles/player_1.png', import.meta.url).href,
                },
                19: {
                    angle: 342,
                    hits: Math.round(Math.random() * 3),
                    color: '#1AD200',
                    avatar: new URL('@/assets/images/profiles/player_1.png', import.meta.url).href,
                },
            },

            colors: ['#0EC1FF', '#FF0000', '#C000FF', '#1AD200'],
        }
    },
    computed: {
        matchStore() {
            return useMatchStore()
        },
        profiles() {
            return this.matchStore.getProfiles
        },
        player1() {
            let profile = this.profiles[0] || null
            profile.avatar = new URL('@/assets/images/profiles/player_1.png', import.meta.url).href
            profile.color = this.colors[Math.round(Math.random() * this.colors.length) - 1]
            return profile
        },
        player2() {
            let profile = this.profiles[1] || null
            profile.avatar = new URL('@/assets/images/profiles/player_2.png', import.meta.url).href
            return profile
        },
    },
    mounted() {
        // The router skips screen_view for game routes so the event can carry the game type.
        const matchId = this.$route.params.matchId ?? this.matchStore.setup?.id
        this.$analytics.trackScreen('Game On - Game', {
            game_type: 'Killer',
            game_context: this.matchStore.isRemotePlay ? 'online' : 'local',
            // Game routes skip trackPageView, so match_id has to be attached here for the
            // in-game events to inherit it as a sticky param.
            ...(matchId ? { match_id: String(matchId) } : {}),
            route_name: this.$route.name,
            path: this.$route.fullPath,
        })
    },
    methods: {
        quitMatch() {
            console.log('Quitting match, clearing match data')
            this.matchStore.clearMatch()
            this.$router.push({ name: 'games' })
        },
        addScore(value, multiplier) {
            if (this.scores.length >= 3) return
            this.scores.push({ value, multiplier })
        },
    },
}
</script>

<style lang="scss">
.killerBg {
    height: 100%;
    width: 100%;
    background: url('@/assets/images/games/killer/killerBg.png');
    background-size: auto 100%;
}

.splashAnimation {
    // display: none;
    animation: splashOut 2s 1 forwards;
    @keyframes splashOut {
        0% {
            display: flex;
            opacity: 1;
        }
        95% {
            display: flex;
            opacity: 1;
        }
        99% {
            display: flex;
            opacity: 0;
        }
        100% {
            display: none;
            opacity: 0;
        }
    }
}
</style>
